'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'

export const MobileWrapper = styled.div<{
  footerWrapperBackground?: string
  footerWrapperBorderTop?: string
}>`
  padding: 30px 20px;

  background: ${({ footerWrapperBackground }) =>
    footerWrapperBackground ? footerWrapperBackground : '#fff'};
  border-top: ${({ footerWrapperBorderTop }) =>
    footerWrapperBorderTop ? footerWrapperBorderTop : '10px solid #fafafa'};
`

export const MobileTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #414a53;
  margin: 30px 0 15px 0;
`

export const MobileLink = styled.a`
  font-size: 14px;
  text-decoration: none;
  color: #151619;
  margin: 10px 0;
  display: block;
`
